import CloseModal from 'assets/images/closeModal.svg?react';
import './styles.scss';

interface ICloseFormProps {
	onClick?: () => void;
}

export default function CloseForm(props: ICloseFormProps) {
	const { onClick } = props;

	return (
		<div className="closeForm" onClick={onClick}>
			<CloseModal />
		</div>
	);
}
